import contextMenu from './context-menu'

export default {
    title: 'Trend radar',
    contextMenu
}
